import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

/**
 * A custom element that renders a media gallery.
 *
 * @typedef {object} Refs
 * @property {import('./zoom-dialog').ZoomDialog} [zoomDialogComponent] - The zoom dialog component.
 * @property {import('./slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {HTMLElement[]} [media] - The media elements.
 *
 * @extends Component<Refs>
 */
export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

  /**
   * Handles a variant update event by replacing the current media gallery with a new one.
   *
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;
    const newMediaGallery = source.querySelector('media-gallery');

    if (!newMediaGallery) return;

    this.replaceWith(newMediaGallery);
  };

  /**
   * Handles the 'zoom-media:selected' event.
   * @param {ZoomMediaSelectedEvent} event - The zoom-media:selected event.
   */
  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  /**
   * Zooms the media gallery.
   *
   * @param {number} index - The index of the media to zoom.
   * @param {PointerEvent} event - The pointer event.
   */
  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}







document.addEventListener('DOMContentLoaded', function () {
  // 只在触摸设备上启用（手机 / 平板）
  var isTouchDevice =
    (window.matchMedia && window.matchMedia('(hover: none)').matches) ||
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0;

  if (!isTouchDevice) return;

  var LONG_PRESS_THRESHOLD = 250; // 长按判定时间（毫秒）

  var wrappers = document.querySelectorAll('.card-gallery-image-wrap--has-second');

  wrappers.forEach(function (wrap) {
    var link = wrap.closest('a');
    if (!link) return;

    var pressTimer = null;
    var longPressActive = false;
    var suppressNextClick = false;

    function startPress(e) {
      // 多指忽略
      if (e.touches && e.touches.length > 1) return;

      longPressActive = true;

      pressTimer = window.setTimeout(function () {
        if (!longPressActive) return;

        wrap.classList.add('card-gallery-image-wrap--second-visible');
        suppressNextClick = true; // 说明这是一次长按预览，不要跳 PDP
      }, LONG_PRESS_THRESHOLD);
    }

    function endPress() {
      longPressActive = false;

      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }

      wrap.classList.remove('card-gallery-image-wrap--second-visible');
    }

    wrap.addEventListener('touchstart', startPress, { passive: true });
    wrap.addEventListener('touchend', endPress);
    wrap.addEventListener('touchcancel', endPress);
    wrap.addEventListener('touchmove', function () {
      // 滑动时，取消长按
      if (!longPressActive) return;
      endPress();
    });

    // 拦截长按之后产生的 click：长按只预览，不导航
    link.addEventListener(
      'click',
      function (e) {
        if (suppressNextClick) {
          e.preventDefault();
          suppressNextClick = false;
        }
      },
      true // 捕获阶段，确保能先于其它监听器执行
    );
  });
});
